import React from "react";
import SidebarDraggableField from "./SidebarDraggableField";
import Icon1 from "../../icons/Icon";
import PrimaryButton from "../../buttons/PrimaryButton";
import SecondaryButton from "../../buttons/SecondaryButton";
import SmallSpinner from "../../loading/SmallSpinner";
import Space from "../../layout/Space";
import Tippy from "@tippyjs/react";
const signFields = ["Signature", "Tampon", "Text", "Date"];

function Sidebar({
  editorMode,
  handleEditorMode,
  handleDownload,
  onSign,
  handleRemoveTextField,
  setIsModalOpen,
  onEdit,
  customTextFields,
  loadingData,
  onClose,
  fields,
  onlyEdit = false,
}) {
  const handlePrepareSignature = () => {
    handleEditorMode("sign");
  };

  const handleEditPDF = () => {
    handleEditorMode("edit");
  };
  return (
    <div className="w-c300  p-5 h-full overflow-auto ">
      {editorMode === "choice" && (
        <div className="flex flex-col gap-2">
          <PrimaryButton onClick={handlePrepareSignature} className="w-fit">
            Préparer une signature
          </PrimaryButton>
          <SecondaryButton onClick={handleEditPDF} className="w-fit">
            Modifier le PDF
          </SecondaryButton>
          <SecondaryButton onClick={handleDownload} className="w-fit">
            Télécharger
          </SecondaryButton>
          <SecondaryButton onClick={() => onClose()} className="w-fit">
            Fermer
          </SecondaryButton>
        </div>
      )}

      {editorMode === "sign" && (
        <div className="flex flex-col gap-2 h-full">
          <div className="text-h2">Champs</div>
          <div className="text-shadow_50 text-h3 mb-1">
            Glissez-déposez les champs sur le PDF pour les positionner. Vous
            pouvez déplacer, redimensionner et modifier le contenu des champs
            texte.
          </div>
          {signFields.map((field) => (
            <SidebarDraggableField key={field} field={field} type={field} />
          ))}
          {customTextFields.map((fieldName, index) => (
            <div
              key={index}
              className="flex flex-row justify-between items-center w-full gap-4"
            >
              <SidebarDraggableField
                key={fieldName}
                field={fieldName}
                type="text"
              />
              <Tippy
                content="Supprimer le champ"
                delay={500}
                className="custom-tooltip"
              >
                <div
                  className="flex items-center cursor-pointer border-shadow_25 border-1rounded-full p-1 border-1 hover:bg-red-400 rounded-full"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the button click when deleting
                    handleRemoveTextField(index);
                  }}
                >
                  <Icon1
                    icon_name="delete"
                    fill="grey"
                    hover_color={"white"}
                    size={18}
                  />
                </div>
              </Tippy>
            </div>
          ))}
          <SecondaryButton
            onClick={() => setIsModalOpen(true)}
            startIcon={<Icon1 icon_name="plus" fill="grey" size={18} />}
            className="w-fit"
          >
            {" "}
            <span className="text-h3"> Nouveau champ</span>
          </SecondaryButton>
          <div className="flex flex-grow w-full gap-2 flex-col justify-end">
            <div className="justify-between gap-2  w-full flex flex-row">
              <SecondaryButton
                className="w-fit"
                onClick={() => {
                  handleEditorMode("choice");
                }}
              >
                Annuler
              </SecondaryButton>
              <PrimaryButton
                className="w-fit"
                onClick={onSign}
                disabled={loadingData}
              >
                <div className="flex flex-row content-center align-middle items-center">
                  Prêt pour signature <Space x={5} />
                  <SmallSpinner loading={loadingData} margin={0} size={20} />
                </div>
              </PrimaryButton>
            </div>
          </div>
        </div>
      )}

      {editorMode === "edit" && (
        <div className="flex flex-col w-c300 p-0 bg-white gap-4 border-r-1-gray-200 h-full rounded-l-xl">
          <SecondaryButton
            className={"w-fit"}
            onClick={() => {
              onlyEdit ? onClose() : handleEditorMode("choice");
            }}
          >
            Annuler
          </SecondaryButton>
          <div className="text-shadow_50 text-h3">
            Déposez un champ texte sur le PDF pour le modifier. Une fois le
            champ texte déposé, vous pouvez le déplacer, le redimensionner et
            modifier son contenu.
          </div>
          <div className="w-c200">
            <SidebarDraggableField
              key="textEdit"
              field="Champ Texte"
              type={"Text"}
              edit={true}
            />
          </div>
          <div className="flex flex-col gap-2">
            <PrimaryButton
              variant="contained"
              className={"w-fit"}
              onClick={onEdit}
              disabled={fields.length === 0 || loadingData}
            >
              Enregistrer les modifications
            </PrimaryButton>{" "}
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
